import { Button, Field } from '@chakra-ui/react';
import FieldErrorMessage from 'src/components/input/FieldErrorMessage';
import RightArrow from 'src/assets/icons/RightArrow';
import { useFormContext } from 'react-hook-form';
import { ReactNode } from 'react';

interface SubmitButtonProps {
  isSubmitting: boolean;
  submissionError: ReactNode | null;
}

export default function SubmitButton({ isSubmitting, submissionError }: SubmitButtonProps) {
  const {
    formState: { errors, isSubmitted },
  } = useFormContext();

  return (
    <>
      {Object.keys(errors).length > 0 && isSubmitted && (
        <Field.Root invalid mt="20px">
          <FieldErrorMessage>
            Oops - there are errors in some of the fields! Please check and correct them.
          </FieldErrorMessage>
        </Field.Root>
      )}
      {!!submissionError && (
        <Field.Root invalid mt="20px">
          <FieldErrorMessage>{submissionError}</FieldErrorMessage>
        </Field.Root>
      )}
      <Button
        type="submit"
        w="100%"
        disabled={isSubmitting}
        mt="38px"
        mb="17px"
        name="register"
        size="lg"
      >
        {isSubmitting ? (
          'Submitting...'
        ) : (
          <>
            Start my free trial <RightArrow />
          </>
        )}
      </Button>
    </>
  );
}
